export default __webpack_public_path__ + "static/media/homepage.11e5c913.jpg";